import { ALL_LOCATIONS } from '@solinkcorp/vd-common';
import React from 'react';
import { LocationStore } from 'stores/LocationStore';
import isShallowEqual from 'utils/isShallowEqual';
import useFluxStore from '../useFluxStore';

export default function useSites() {
  const { sitesById, sites } = useFluxStore(
    LocationStore,
    (store) => ({
      sitesById: store.getLocationsById(),
      sites: store.getLocations(),
    }),
    isShallowEqual,
  );

  return { sitesById, sites };
}

export function useSitesWithoutAllLocations() {
  const { sites } = useSites();
  return React.useMemo(() => sites.filter((site) => site.id !== ALL_LOCATIONS), [sites]);
}
